import footerTemplateHtml from "../templates/footer-outdoor";
import {
  csHelpPhoneNumber,
  updateClassNames,
  isUserLoggedIn,
  appendCountryLanguage,
  initializeLightbox,
  hideElementInIframe,
  showVirtualAdvisorFooterLinks,
  showAppStore,
  addEmailSignupLinkClickListeners,
  getCountry,
  getLanguage,
  toggleForStaff,
  isWebview,
  getIsStaffUser,
  getIsAuthenticated,
} from "./GeneralHelpers";
import { setLinkClickedAnalyticsListeners, setNavigationLinkClickedAnalyticsListeners } from "./Analytics";

class FooterOutdoor extends HTMLElement {
  constructor() {
    super();

    if (!isWebview()) {
      this.root = this.attachShadow({ mode: "open" });
    }
  }

  connectedCallback() {
    this.connectedCallbackRequired();

    if (isWebview()) {
      // Mobile specific logic here
      // ...
      // ...
    } else {
      // this.connectedCallbackUI();
    }
  }

  connectedCallbackRequired() {
    this.country = getCountry(this);
    this.language = getLanguage(this);
    this.isStaffUser = getIsStaffUser(this);
    this.isAuthenticated = getIsAuthenticated(this);
  }

  connectedCallbackUI() {
    // Add footer content to body
    const footerTemplate = document.createElement("template");
    const translations = require(`../../utils/translation-data_${this.language}.js`).data;
    footerTemplate.innerHTML = footerTemplateHtml(translations, this.country, this.language, this.isStaffUser);
    this.root.appendChild(footerTemplate.content.cloneNode(true));
    showAppStore(this.root, this.language.toUpperCase());
    this.root.querySelector(".tel-number").innerHTML = csHelpPhoneNumber(this.country);
    // Adds computed class names to the container.
    // 2022-10-19 example : OUTDOOR NOTLOGGEDIN CA ENGLISH FULLWIDTH EN TWOUP UTILITY HOME
    updateClassNames(this.root, ".OUTDOOR", this.country, this.language);
    this.addLanguageToRecallLink(this.root, this.language);
    this.bindEvents(this.root);
    this.bindListeners(this.root);
    addEmailSignupLinkClickListeners(this.root, this.country);
    isUserLoggedIn(this.root, ".OUTDOOR", this.isAuthenticated);
    isUserLoggedIn(document, "body", this.isAuthenticated);
    appendCountryLanguage(this.root, this.country, this.language);
    initializeLightbox(document);
    initializeLightbox(this.root);
    hideElementInIframe(this.root, ".OUTDOOR");
    showVirtualAdvisorFooterLinks(this.country, this.language, this.root);

    this.root.querySelectorAll(".footer-ftue .country").forEach(el => {
      el.innerHTML = this.country.toUpperCase();
    });
    this.root.querySelectorAll(".footer-ftue .language").forEach(el => {
      el.innerHTML = this.language.toUpperCase();
    });
  }

  bindEvents(el) {
    el.querySelectorAll(".footer-ftue .flag").forEach(el => {
      el.classList.add(`flag-${this.country.toUpperCase()}`);
      el.addEventListener("click", () => {
        const flagEv = new Event("ARCTERYXUICOMPONENTS.localeClick", { bubbles: true, cancelable: false });
        flagEv.initEvent("ARCTERYXUICOMPONENTS.localeClick", true, true);
        this.dispatchEvent(flagEv);
      });
    });

    el.querySelectorAll(".footer-ftue .lang-selector").forEach(el => {
      el.addEventListener("click", () => {
        const flagEv = new Event("ARCTERYXUICOMPONENTS.localeClick", { bubbles: true, cancelable: false });
        flagEv.initEvent("ARCTERYXUICOMPONENTS.localeClick", true, true);
        this.dispatchEvent(flagEv);
      });
    });

    // Use this eventListener to update footer links for authenticated vs guest users
    window.addEventListener("update-user-auth", () => {
      this.isAuthenticated = getIsAuthenticated(this);
      isUserLoggedIn(this.root, ".OUTDOOR", this.isAuthenticated);
    });

    // Use this eventListener to hide footer for staff links via css
    window.addEventListener("hide-footer-links-for-staff", () => {
      toggleForStaff(this.root, ".OUTDOOR .isStaff", false);
    });

    // Use this eventListener to show footer for staff links via css
    window.addEventListener("show-footer-links-for-staff", () => {
      toggleForStaff(this.root, ".OUTDOOR .isStaff", true);
    });
    setLinkClickedAnalyticsListeners(el, ".footerMenu a", "footer");
    setLinkClickedAnalyticsListeners(el, ".bottom-bar a", "footer");
    setNavigationLinkClickedAnalyticsListeners(el, "#mobExplore a");
    setNavigationLinkClickedAnalyticsListeners(el, "#mobFootwear a");
  }

  bindListeners(el) {
    el.querySelector("#mobExplore .body3").addEventListener("click", () => {
      if (el.querySelector(".mob-explore").classList.contains("expanded")) {
        el.querySelector(".mob-explore").classList.remove("expanded");
      } else {
        el.querySelector(".mob-explore").classList.add("expanded");
      }
      if (el.querySelector("#mobExplore .body3").classList.contains("open")) {
        el.querySelector("#mobExplore .body3").classList.remove("open");
      } else {
        el.querySelector("#mobExplore .body3").classList.add("open");
      }
    });
    el.querySelector("#mobFootwear .body3").addEventListener("click", () => {
      if (el.querySelector(".mob-footwear").classList.contains("expanded")) {
        el.querySelector(".mob-footwear").classList.remove("expanded");
      } else {
        el.querySelector(".mob-footwear").classList.add("expanded");
      }
      if (el.querySelector("#mobFootwear .body3").classList.contains("open")) {
        el.querySelector("#mobFootwear .body3").classList.remove("open");
      } else {
        el.querySelector("#mobFootwear .body3").classList.add("open");
      }
    });
  }

  addLanguageToRecallLink(el, language) {
    const recallLink = el.querySelector(".recall-link");
    if (recallLink) {
      const href = recallLink.getAttribute("href");
      recallLink.href = `${href}/${language}/procline-boot/`;
    }
  }
}

export default FooterOutdoor;
